module.exports = __webpack_public_path__ + "./assets/spacio_logo.png";